import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CardFormComponent } from './cardform.component';
import { ShowActionPipe } from './cardform.pipe';
import { CardFormRoutingModule } from './cardform.routing.module';
import { ErrorModule } from '../../components/error/error.module';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { MomentModule } from 'angular2-moment';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CardFormRoutingModule,
    ErrorModule,
    SpinnerModule,
    MomentModule
  ],
  exports: [
    CardFormComponent
  ],
  declarations: [
    CardFormComponent,
    ShowActionPipe
  ]
})
export class CardFormModule { }
